import React, {useState, useEffect} from 'react';
import {hostUrl, tokenExpiredLoginAgain, setSpinner, siteUrl, highTrafficInnerPages, invalidUsername, invalidPassword, highTrafficLogin, passwordWeak, passwordMedium, confirPasswordNotMatched } from '../../constants/global';
import { useSelector, useDispatch } from 'react-redux';
import allActions from '../../actions/index';
import { Link } from 'react-router-dom';
import {useNavigate} from "react-router-dom";
import {shortNameUser, formatPostDate} from '../common/Helper';
import BannerImg from '../../assets/images/banner-img.svg';
import { callPageRenderTracking } from '../common/Helper';



function TopicList() {

   var currentItems;

   var loadingSection = <>
          <div class="topic-list loader-data">
            <div class="answers-info-image">AU</div>
            <div class="topic_name"></div>
            <div class="post-list-info"></div>
            <div class="topic_content"></div>
            <div class="topic_content"></div>
          </div>
          <div class="topic-list loader-data">
            <div class="answers-info-image">AU</div>
            <div class="topic_name"></div>
            <div class="post-list-info"></div>
            <div class="topic_content"></div>
            <div class="topic_content"></div>
          </div>
          <div class="topic-list loader-data">
            <div class="answers-info-image">AU</div>
            <div class="topic_name"></div>
            <div class="post-list-info"></div>
            <div class="topic_content"></div>
            <div class="topic_content"></div>
          </div>
        </>;

   const topicBucketState =  useSelector(state => state.TopicBucket);
   const dispatch = useDispatch();
   const navigate = useNavigate();

   var data = topicBucketState.bucket.owner_question;

   const [currentPage, setcurrentPage] = useState(1);
   const [itemsPerPage, setitemsPerPage] = useState(10);

   const [pageNumberLimit, setpageNumberLimit] = useState(5);
   const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
   const [minPageNumberLimit, setminPageNumberLimit] = useState(0);

   var pages = [];
   if(data){
    for (let i = 1; i <= Math.ceil(data.length / itemsPerPage); i++) {
      pages.push(i);
    }
   }

   const indexOfLastItem = currentPage * itemsPerPage;
   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
   if(data){
    currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
   }

   const handleClick = (e) => {
    setcurrentPage(Number(e.target.id));
   }
  
    var renderPageNumbers = pages.map((number)=> {
        if(number < maxPageNumberLimit+1 && number > minPageNumberLimit){
            return <li key={number} className={currentPage ==  number ? "active" : null}><button id={number} type='button' onClick={handleClick}>{number}</button></li>
        }else{
            return null;
        }
    });


    //document.body.classList.add('white-bg-header');
    
    useEffect(() => {
      console.log("in use Effect");

      callPageRenderTracking({page_title:'Topic List',page_link:window.location.href});

      if(topicBucketState.datatrack===1){
              /******get data from localstorage*******/
              let authlogin = localStorage.getItem('authlogin');
              let storageData = authlogin ? JSON.parse(authlogin) : "";
              
              var token = 'Bearer '+storageData.token;
              var username = storageData.user_email;
        
              const data = { callingaction: 'topic_list' };

              const requestOptions = {
                      method: 'POST',
                      //mode:'cors',
                      headers: { 'Content-Type': 'application/json', 
                      'POST' : '/resource HTTP/1.1',
                      'Authorization': token,
                      'Host' : hostUrl,
                      'username' : username,
                      body: JSON.stringify(data),
                      }
                  };

              fetch(siteUrl+'/community-rest-functions.php?action=topic_handle',requestOptions)
              .then((response) => response.json())
              .then(function(actualData){ 
                  console.log(actualData);
                  if(actualData.status=='success'){
                    dispatch( allActions.TopicData.setTopicData(actualData));
                  }else if(actualData.status=='validationerror'){
                    dispatch( allActions.ModalPopup.showPopup({ popupname:'alertbox', title: tokenExpiredLoginAgain}));
                    //alert(tokenExpiredLoginAgain);
                    navigate('/login/?message='+tokenExpiredLoginAgain);
                  }
                  //setResponseMessage({status:"success",message:"We have send the topic for approval"});
              
              }).catch(rejected => {
                  //setResponseMessage({status:"error",message:highTrafficInnerPages});
              });

          }

          /*******add class on body*****/
          document.body.classList.add('white-bg-header');
          return () => {
            document.body.classList.remove('white-bg-header');
          }

    },[]);


  const handlePreviousClick = () => {
      setcurrentPage(currentPage - 1);

      if( (currentPage - 1) % pageNumberLimit == 0 ){
          setmaxPageNumberLimit(maxPageNumberLimit - pageNumberLimit);
          setminPageNumberLimit(minPageNumberLimit - pageNumberLimit);
      }
  }
  
  const handleNextClick = () => {
      setcurrentPage(currentPage + 1);

      if(currentPage+1 > maxPageNumberLimit){
          setmaxPageNumberLimit(maxPageNumberLimit + pageNumberLimit);
          setminPageNumberLimit(minPageNumberLimit + pageNumberLimit);
      }
  }


    let pageIncrementBtn = null;
    if (pages.length > maxPageNumberLimit) {
      pageIncrementBtn = <li><button type='button' onClick={handleNextClick}>&hellip;</button></li>;
    }

    let pageDecrementBtn = null;
    if (minPageNumberLimit >= 1) {
      pageDecrementBtn = <li><button type='button' onClick={handlePreviousClick}>&hellip;</button></li>;
    }


    const TopicListData = (currentItems) => {
    
      /******get data from localstorage*******/
      let authlogin = localStorage.getItem('authlogin');
      let storageDataAuthLogin = authlogin ? JSON.parse(authlogin) : "";

      if(currentItems.length==0){
        return <h3 style={{textAlign:'center', color:"black"}}>Topics not found</h3>
      }

      return currentItems.map((element,index) => {
        
          var user_short_name = shortNameUser(element.author_name);

          var post_content = element.post_content;

          if(element.post_content.length>250){
             post_content = element.post_content.substr(0,250)+"...";
          }

          var formatDate = formatPostDate(element.post_date);
          return <Link className='parent-figure' to={"/topic/"+element.ID}>
            
              <div className='topic-list' key={element.ID}>
              
              <div className='answers-info-image'>{element.post_anonymously === "1" ? "U" : user_short_name}</div>
              <div className="topic_name">{element.post_title}</div>
              <div className='post-list-info'>
                <div className='info-col'><span className="material-icons-outlined"> calendar_month </span> {formatDate}</div>
                <div className='info-space'>|</div>
                <div className='info-col'><span className="material-icons-outlined">person</span> {element.post_anonymously === "1" ? "User"+element.post_author : element.author_name}</div>
                <div className='info-space'>|</div>
                <div className='info-col'><span className="material-icons-outlined">comment</span> {element.reply_count ? element.reply_count : "N/A"}</div>
              </div>
              <div className="topic_content"><div className="content" dangerouslySetInnerHTML={{__html: post_content}}></div></div> 
          </div>
          </Link>

        }
      )
    }
  
 
  return (
    <div className='fullpage-box knowledge-fullpage-box topic-content-box p-l-0 p-r-0'>

    {/* Banner start */}
    <div className='topic-banner'>
    <div className="topic-container">
    <div className='inner-container'>
      <h1 className='topic-banner-title'>All Topics</h1>
      <p>Discuss, Connect and Collaborate: Ask your queries and get answers from the experts</p>
      <div className='banner-image'><img src={BannerImg} alt="" /></div>
    </div>
    </div>
    </div>
    {/* Banner End */}


    <div className="topic-container topic-list-container">

        <div className='topic-list-box'>

        {/********loading section*******/}
        {topicBucketState.datatrack == 1 && loadingSection}

        {topicBucketState.datatrack == 0 && <>
            {TopicListData(currentItems)}
        </>  }

        </div>

        {(currentItems && data.length>10) && 

        <div className='pageNumbers'>
        <ul>
                <li><button type='button' onClick={handlePreviousClick} disabled={currentPage == pages[0] ? true : false}>Prev</button></li>
                
                {pageDecrementBtn}
                {renderPageNumbers}
                {pageIncrementBtn}

                
                <li><button type='button' onClick={handleNextClick} disabled={currentPage == pages[pages.length - 1] ? true : false}>Next</button></li>
        </ul>
        </div>

      }


    </div>
    </div>
  )
}

export default TopicList;